// Generated by scripts/build-ui-icons.mjs.
import { createAppIcon } from "./base";
import { AddressBookIcon as AddressBookGlyph } from "@phosphor-icons/react/dist/ssr/AddressBook";
import { ArchiveIcon as ArchiveGlyph } from "@phosphor-icons/react/dist/ssr/Archive";
import { ArmchairIcon as ArmchairGlyph } from "@phosphor-icons/react/dist/ssr/Armchair";
import { ArrowBendUpLeftIcon as ArrowBendUpLeftGlyph } from "@phosphor-icons/react/dist/ssr/ArrowBendUpLeft";
import { ArrowBendUpRightIcon as ArrowBendUpRightGlyph } from "@phosphor-icons/react/dist/ssr/ArrowBendUpRight";
import { ArrowClockwiseIcon as ArrowClockwiseGlyph } from "@phosphor-icons/react/dist/ssr/ArrowClockwise";
import { ArrowCounterClockwiseIcon as ArrowCounterClockwiseGlyph } from "@phosphor-icons/react/dist/ssr/ArrowCounterClockwise";
import { ArrowDownIcon as ArrowDownGlyph } from "@phosphor-icons/react/dist/ssr/ArrowDown";
import { ArrowDownLeftIcon as ArrowDownLeftGlyph } from "@phosphor-icons/react/dist/ssr/ArrowDownLeft";
import { ArrowDownRightIcon as ArrowDownRightGlyph } from "@phosphor-icons/react/dist/ssr/ArrowDownRight";
import { ArrowLeftIcon as ArrowLeftGlyph } from "@phosphor-icons/react/dist/ssr/ArrowLeft";
import { ArrowRightIcon as ArrowRightGlyph } from "@phosphor-icons/react/dist/ssr/ArrowRight";
import { ArrowSquareOutIcon as ArrowSquareOutGlyph } from "@phosphor-icons/react/dist/ssr/ArrowSquareOut";
import { ArrowUpIcon as ArrowUpGlyph } from "@phosphor-icons/react/dist/ssr/ArrowUp";
import { ArrowUpRightIcon as ArrowUpRightGlyph } from "@phosphor-icons/react/dist/ssr/ArrowUpRight";
import { ArrowsClockwiseIcon as ArrowsClockwiseGlyph } from "@phosphor-icons/react/dist/ssr/ArrowsClockwise";
import { ArrowsDownUpIcon as ArrowsDownUpGlyph } from "@phosphor-icons/react/dist/ssr/ArrowsDownUp";
import { ArrowsInIcon as ArrowsInGlyph } from "@phosphor-icons/react/dist/ssr/ArrowsIn";
import { ArrowsInLineHorizontalIcon as ArrowsInLineHorizontalGlyph } from "@phosphor-icons/react/dist/ssr/ArrowsInLineHorizontal";
import { ArrowsLeftRightIcon as ArrowsLeftRightGlyph } from "@phosphor-icons/react/dist/ssr/ArrowsLeftRight";
import { ArrowsOutIcon as ArrowsOutGlyph } from "@phosphor-icons/react/dist/ssr/ArrowsOut";
import { ArrowsOutCardinalIcon as ArrowsOutCardinalGlyph } from "@phosphor-icons/react/dist/ssr/ArrowsOutCardinal";
import { BankIcon as BankGlyph } from "@phosphor-icons/react/dist/ssr/Bank";
import { BeerSteinIcon as BeerSteinGlyph } from "@phosphor-icons/react/dist/ssr/BeerStein";
import { BellIcon as BellGlyph } from "@phosphor-icons/react/dist/ssr/Bell";
import { BellRingingIcon as BellRingingGlyph } from "@phosphor-icons/react/dist/ssr/BellRinging";
import { BookIcon as BookGlyph } from "@phosphor-icons/react/dist/ssr/Book";
import { BookOpenIcon as BookOpenGlyph } from "@phosphor-icons/react/dist/ssr/BookOpen";
import { BookmarkSimpleIcon as BookmarkSimpleGlyph } from "@phosphor-icons/react/dist/ssr/BookmarkSimple";
import { BoxArrowUpIcon as BoxArrowUpGlyph } from "@phosphor-icons/react/dist/ssr/BoxArrowUp";
import { BrainIcon as BrainGlyph } from "@phosphor-icons/react/dist/ssr/Brain";
import { BriefcaseIcon as BriefcaseGlyph } from "@phosphor-icons/react/dist/ssr/Briefcase";
import { BroadcastIcon as BroadcastGlyph } from "@phosphor-icons/react/dist/ssr/Broadcast";
import { BuildingIcon as BuildingGlyph } from "@phosphor-icons/react/dist/ssr/Building";
import { BuildingsIcon as BuildingsGlyph } from "@phosphor-icons/react/dist/ssr/Buildings";

export const AddressBook = /* @__PURE__ */ createAppIcon(
  AddressBookGlyph,
  "AddressBook",
);
export const Archive = /* @__PURE__ */ createAppIcon(ArchiveGlyph, "Archive");
export const Armchair = /* @__PURE__ */ createAppIcon(
  ArmchairGlyph,
  "Armchair",
);
export const ArrowBendUpLeft = /* @__PURE__ */ createAppIcon(
  ArrowBendUpLeftGlyph,
  "ArrowBendUpLeft",
);
export const ArrowBendUpRight = /* @__PURE__ */ createAppIcon(
  ArrowBendUpRightGlyph,
  "ArrowBendUpRight",
);
export const ArrowClockwise = /* @__PURE__ */ createAppIcon(
  ArrowClockwiseGlyph,
  "ArrowClockwise",
);
export const ArrowCounterClockwise = /* @__PURE__ */ createAppIcon(
  ArrowCounterClockwiseGlyph,
  "ArrowCounterClockwise",
);
export const ArrowDown = /* @__PURE__ */ createAppIcon(
  ArrowDownGlyph,
  "ArrowDown",
);
export const ArrowDownLeft = /* @__PURE__ */ createAppIcon(
  ArrowDownLeftGlyph,
  "ArrowDownLeft",
);
export const ArrowDownRight = /* @__PURE__ */ createAppIcon(
  ArrowDownRightGlyph,
  "ArrowDownRight",
);
export const ArrowLeft = /* @__PURE__ */ createAppIcon(
  ArrowLeftGlyph,
  "ArrowLeft",
);
export const ArrowRight = /* @__PURE__ */ createAppIcon(
  ArrowRightGlyph,
  "ArrowRight",
);
export const ArrowSquareOut = /* @__PURE__ */ createAppIcon(
  ArrowSquareOutGlyph,
  "ArrowSquareOut",
);
export const ArrowUp = /* @__PURE__ */ createAppIcon(ArrowUpGlyph, "ArrowUp");
export const ArrowUpRight = /* @__PURE__ */ createAppIcon(
  ArrowUpRightGlyph,
  "ArrowUpRight",
);
export const ArrowsClockwise = /* @__PURE__ */ createAppIcon(
  ArrowsClockwiseGlyph,
  "ArrowsClockwise",
);
export const ArrowsDownUp = /* @__PURE__ */ createAppIcon(
  ArrowsDownUpGlyph,
  "ArrowsDownUp",
);
export const ArrowsIn = /* @__PURE__ */ createAppIcon(
  ArrowsInGlyph,
  "ArrowsIn",
);
export const ArrowsInLineHorizontal = /* @__PURE__ */ createAppIcon(
  ArrowsInLineHorizontalGlyph,
  "ArrowsInLineHorizontal",
);
export const ArrowsLeftRight = /* @__PURE__ */ createAppIcon(
  ArrowsLeftRightGlyph,
  "ArrowsLeftRight",
);
export const ArrowsOut = /* @__PURE__ */ createAppIcon(
  ArrowsOutGlyph,
  "ArrowsOut",
);
export const ArrowsOutCardinal = /* @__PURE__ */ createAppIcon(
  ArrowsOutCardinalGlyph,
  "ArrowsOutCardinal",
);
export const Bank = /* @__PURE__ */ createAppIcon(BankGlyph, "Bank");
export const BeerStein = /* @__PURE__ */ createAppIcon(
  BeerSteinGlyph,
  "BeerStein",
);
export const Bell = /* @__PURE__ */ createAppIcon(BellGlyph, "Bell");
export const BellRinging = /* @__PURE__ */ createAppIcon(
  BellRingingGlyph,
  "BellRinging",
);
export const Book = /* @__PURE__ */ createAppIcon(BookGlyph, "Book");
export const BookOpen = /* @__PURE__ */ createAppIcon(
  BookOpenGlyph,
  "BookOpen",
);
export const BookmarkSimple = /* @__PURE__ */ createAppIcon(
  BookmarkSimpleGlyph,
  "BookmarkSimple",
);
export const BoxArrowUp = /* @__PURE__ */ createAppIcon(
  BoxArrowUpGlyph,
  "BoxArrowUp",
);
export const Brain = /* @__PURE__ */ createAppIcon(BrainGlyph, "Brain");
export const Briefcase = /* @__PURE__ */ createAppIcon(
  BriefcaseGlyph,
  "Briefcase",
);
export const Broadcast = /* @__PURE__ */ createAppIcon(
  BroadcastGlyph,
  "Broadcast",
);
export const Building = /* @__PURE__ */ createAppIcon(
  BuildingGlyph,
  "Building",
);
export const Buildings = /* @__PURE__ */ createAppIcon(
  BuildingsGlyph,
  "Buildings",
);
